import "./ComparisonPage.css";

export default function ComparisonPage() {
  const data = [
    {
      title: "Stone Value Inclusion",
      bad: "Only the Gold Value",
      good: "Full transparency – gold + stone value included",
    },
    {
      title: "Branch Accessibility",
      bad: "Limited presence",
      good: "Available across South India",
    },
    {
      title: "Gold Pricing",
      bad: "Fixed pricing",
      good: "Live market-based pricing",
    },
    {
      title: "Team Expertise",
      bad: "Inexperienced staff",
      good: "Well-trained professionals",
    },
    {
      title: "21 Days Interest Free Period",
      bad: "Not available",
      good: "21-day interest-free offers",
    },
  ];

  return (
    <section className="gold-section">

      <h1 className="gold-title">What Makes Us Different</h1>

      <div className="gold-container">

        {data.map((item, index) => (
          <div className="gold-row" key={index}>

            <div className="gold-feature">
              {item.title}
            </div>

            <div className="gold-box bad">
              <span>✖</span>
              <p>{item.bad}</p>
            </div>

            <div className="gold-box good">
              <span>✔</span>
              <p>{item.good}</p>
            </div>

          </div>
        ))}

      </div>

    </section>
  );
}